
type ProductChangeListener = (productId: number) => void;

const listeners = new Set<ProductChangeListener>();

const emitProductChanged = (productId: number): void => {
  listeners.forEach((listener) => listener(productId));
};

const onProductChanged = (listener: ProductChangeListener): (() => void) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const productEvents = {
  emitProductChanged,
  onProductChanged,
};

export default productEvents;
